import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../../AppProvider";
import {
  faPlus,
  faArrowDownShortWide,
  faArrowUpShortWide,
} from "@awesome.me/kit-c1b85ff10f/icons/classic/light";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "../../../utilities/fontawesomeIcons";
import { useIndexCompaniesContext } from "../providers/Index";
import { getCompanyPath } from ".";

export const useListProps = () => {
  const { dictionary, accessTokenPayload } = useAppContext();
  const navigate = useNavigate();
  const context = useIndexCompaniesContext();

  const getTitle = (type, isPlural = false) => {
    const key = {
      CUSTOMER: isPlural ? "customers" : "customer",
      AFILIATE: isPlural ? "affiliates" : "affiliate",
      ORGANIZATION: isPlural ? "organizations" : "organization",
    }[type];

    return key ? dictionary.registries[key] : "";
  };

  return {
    path: "/registry-service/companies",
    banner: { enabled: true },
    pagination: { enabled: true },
    create: {
      enabled: true,
      action: () => {
        navigate(`/${getCompanyPath(context.type)}/create`);
      },
      title: `${
        context.type === "ORGANIZATION"
          ? dictionary.words.new_sf
          : dictionary.words.new_sm
      } ${getTitle(context.type)}`,
      icon: faPlus,
    },
    sorting: [
      {
        orderBy: "desc",
        column: "externalReference",
        icon: faArrowDownShortWide,
        label: dictionary.references.external_reference,
        isDefault: false,
      },
      {
        orderBy: "asc",
        column: "externalReference",
        icon: faArrowUpShortWide,
        label: dictionary.references.external_reference,
        isDefault: false,
      },
      {
        orderBy: "desc",
        column: "name",
        icon: faArrowDownShortWide,
        label: dictionary.registries.name,
        isDefault: false,
      },
      {
        orderBy: "asc",
        column: "name",
        icon: faArrowUpShortWide,
        label: dictionary.registries.name,
        isDefault: true,
      },
    ],
    title: getTitle(context.type, true),
    selectRowsEnabled: { enabled: true },
    massiveActions: [
      {
        onClick: (selectedRows) =>
          context.setModalConfig({
            isOpen: true,
            title: dictionary.actions.delete_selected,
            action: "delete",
            data: selectedRows.map((item) => item.id),
          }),
        label: dictionary.actions.delete_selected,
        icon: <FontAwesomeIcon icon={faTrash} />,
        className: "button-1 button-1-danger",
      },
    ],
    filters: {
      name: getTitle(context.type, true),
      preserve: false,
      list: [
        {
          fieldName: "name",
          label: dictionary.registries.name,
          type: "text",
          primary: true,
          col: 3,
        },
        {
          fieldName: "externalReference",
          label: dictionary.references.external_reference,
          type: "text",
          primary: true,
          col: 3,
        },
        {
          fieldName: "vatNumber",
          label: dictionary.registries.vat_number,
          type: "text",
          primary: true,
          col: 3,
        },
        {
          fieldName: "organization.id",
          type: "text",
          value: accessTokenPayload.owner,
          hidden: true,
          primary: false,
        },
        {
          fieldName: "type",
          type: "text",
          value: context.type,
          hidden: true,
          primary: false,
        },
      ],
    },
  };
};
